import { curry } from 'ramda';

export const createRouteName = (parent = '', child = '') => `${parent}/${child}`;
export const createRoutePath = (parent = '', child = '') => `${parent}/:${child}`;

// TODO: Move these booking Route declarations from here to their respective route files
// These are here because of undefined error when imported on components 

export const bookingTasks = 'booking_tasks';
export const bookingRequestsRouterName = 'booking_requests';
export const bookingRequestsWizardRouterName = createRouteName(bookingRequestsRouterName, 'calendar_date_id');

export const bookingPromotersRouterName = 'booking_promoters';

// const bookingListR = 'booking_list';
// const bookingListCalendarDate = createRouteName(bookingListR, 'calendar_date_id');
// const bookingListCalendarDateTab = createRouteName(bookingListCalendarDate, 'tab');

// export const bookingListCal = 'booking_list_calendar';
// export const bookingListCalCalendarDate = createRouteName(bookingListCal, 'calendar_date_id');
// export const bookingListCalCalendarDateTab = createRouteName(bookingListCal, 'tab');

export const childOfOrEqual = curry((parent, child) => {
  // console.error(parent, child);
  return child.startsWith(parent) || child === parent;
});
export const childOfOrEqualSome = curry((parents, child) => {
  // console.log(parents, child, 'parents.some(parent => child.startsWith(parent) || child === parent)', parents.some(parent => child.startsWith(parent) || child === parent));
  return parents.some(parent => child.startsWith(parent) || child === parent);
});

export const childOf = curry((parent, child) => {
  return child.startsWith(parent) && child !== parent;
});
